export const socialLinks = {
  github: "https://github.com/WSOL12",
  telegram: "https://t.me/wsol0012",
  discord: "https://discord.com/users/367009301090402325",
  gmail: "mailto:hitechlan2008@gmail.com",
};
